export default "__VITE_ASSET__BQhhw4sO__"